/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: frLTK57AGre4oWC8c14hh8
// Component: mTPcI1ndDUTm

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { Embed } from "@plasmicpkgs/plasmic-basic-components";
import Button from "../../Button"; // plasmic-import: Cr5zp7a53Igt/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: frLTK57AGre4oWC8c14hh8/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: frLTK57AGre4oWC8c14hh8/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicTC.module.css"; // plasmic-import: mTPcI1ndDUTm/css

import CircleIcon from "./icons/PlasmicIcon__Circle"; // plasmic-import: 9sHJQRmA0elH/icon
import ChevronDownIcon from "./icons/PlasmicIcon__ChevronDown"; // plasmic-import: BcA8RyhY-uEx/icon

const emptyProxy: any = new Proxy(() => "", {
  get(_, prop) {
    return prop === Symbol.toPrimitive ? () => "" : emptyProxy;
  }
});

function wrapQueriesWithLoadingProxy($q: any): any {
  return new Proxy($q, {
    get(target, queryName) {
      const query = target[queryName];
      return !query || query.isLoading || !query.data ? emptyProxy : query;
    }
  });
}

export type PageCtx = {
  pageRoute: string;
  pagePath: string;
  params: Record<string, string | string[] | undefined>;
  query: Record<string, string | string[] | undefined>;
};

export function generateDynamicMetadata($q: any, $ctx: PageCtx) {
  return {
    title: "Všeobecné obchodní podmínky",

    openGraph: {
      title: "Všeobecné obchodní podmínky"
    },
    twitter: {
      card: "summary" as const,
      title: "Všeobecné obchodní podmínky"
    }
  };
}

createPlasmicElementProxy;

export type PlasmicTC__VariantMembers = {};
export type PlasmicTC__VariantsArgs = {};
type VariantPropType = keyof PlasmicTC__VariantsArgs;
export const PlasmicTC__VariantProps = new Array<VariantPropType>();

export type PlasmicTC__ArgsType = {};
type ArgPropType = keyof PlasmicTC__ArgsType;
export const PlasmicTC__ArgProps = new Array<ArgPropType>();

export type PlasmicTC__OverridesType = {
  root?: Flex__<"div">;
  freeBox?: Flex__<"div">;
  embedHtml?: Flex__<typeof Embed>;
  button?: Flex__<typeof Button>;
  text?: Flex__<"div">;
};

export interface DefaultTCProps {}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicTC__RenderFunc(props: {
  variants: PlasmicTC__VariantsArgs;
  args: PlasmicTC__ArgsType;
  overrides: PlasmicTC__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const pageMetadata = generateDynamicMetadata(
    wrapQueriesWithLoadingProxy({}),
    $ctx as PageCtx
  );

  const styleTokensClassNames = _useStyleTokens();

  return (
    <React.Fragment>
      <Head>
        <meta name="twitter:card" content="summary" />
        <title key="title">{pageMetadata.title}</title>
        <meta key="og:title" property="og:title" content={pageMetadata.title} />
        <meta
          key="twitter:title"
          property="twitter:title"
          content={pageMetadata.title}
        />
      </Head>

      <style>{`
        body {
          margin: 0;
        }
      `}</style>

      <div className={"plasmic_page_wrapper"}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            "all",
            "root_reset_frLTK57AGre4oWC8c14hh8",
            "plasmic_default_styles",
            "plasmic_mixins",
            styleTokensClassNames,
            sty.root
          )}
        >
          <div
            data-plasmic-name={"freeBox"}
            data-plasmic-override={overrides.freeBox}
            className={classNames("all", sty.freeBox)}
          >
            <Embed
              data-plasmic-name={"embedHtml"}
              data-plasmic-override={overrides.embedHtml}
              className={classNames("__wab_instance", sty.embedHtml)}
              code={
                '<div class="vop-content">\n  <style>\n    .vop-content {\n      font-family: "Nunito", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;\n      color: #212529;\n      line-height: 1.6;\n      max-width: 1200px;\n      margin: 0 auto;\n      padding: 24px;\n      font-size: 18px;\n      font-weight: 400;\n      text-align: left;\n    }\n    .vop-content h1 {\n      font-size: 36px;\n      font-weight: 700;\n      line-height: 1.25;\n      margin: 0 0 1.5rem 0;\n      text-align: left;\n      color: #212529;\n    }\n    .vop-content h2 {\n      font-size: 30px;\n      font-weight: 700;\n      line-height: 1.3;\n      margin: 2.25rem 0 1rem 0;\n      text-align: left;\n      color: #212529;\n    }\n    .vop-content ol {\n      padding-left: 1.5rem;\n      margin: 0 0 1rem 0;\n    }\n    .vop-content ol > li {\n      margin-bottom: 0.85rem;\n    }\n    .vop-content ol ol {\n      margin-top: 0.5rem;\n      list-style-type: decimal;\n    }\n    .vop-content ol ol > li {\n      margin-bottom: 0.4rem;\n    }\n    .vop-content p {\n      margin: 0 0 1rem 0;\n    }\n    .vop-content a {\n      color: #1d4ed8;\n      text-decoration: underline;\n    }\n    .vop-content .effective-date {\n      margin-top: 2rem;\n      font-weight: 500;\n    }\n  </style>\n\n  <h1>V\u0161eobecn\u00e9 obchodn\u00ed podm\u00ednky zprost\u0159edkovatele FinBakers s.r.o.</h1>\n\n  <h2>\u010cl. 1. \u00davodn\u00ed ustanoven\u00ed</h2>\n  <ol>\n    <li>Tyto obchodn\u00ed podm\u00ednky zprost\u0159edkov\u00e1n\u00ed spot\u0159ebitelsk\u00e9ho \u00fav\u011bru (d\u00e1le jen \u201eObchodn\u00ed podm\u00ednky\u201c) vydala obchodn\u00ed spole\u010dnost FinBakers s.r.o., I\u010cO 09151541, se s\u00eddlem Na Folimance 2155/15, 120 00 Praha 2 - Vinohrady, zapsan\u00e1 v obchodn\u00edm rejst\u0159\u00edku veden\u00e9m M\u011bstsk\u00fdm soudem v Praze pod sp. zn. C 331699 (d\u00e1le jen \u201eZprost\u0159edkovatel\u201c).</li>\n    <li>Zprost\u0159edkovatel je d\u00e1le opr\u00e1vn\u011bn zprost\u0159edkovat spot\u0159ebitelsk\u00fd \u00fav\u011br jako\u017eto samostatn\u00fd zprost\u0159edkovatel spot\u0159ebitelsk\u00e9ho \u00fav\u011bru na z\u00e1klad\u011b povolen\u00ed ze dne 22. 6. 2020, a je zaps\u00e1n v registru veden\u00e9m \u010ceskou n\u00e1rodn\u00ed bankou dostupn\u00e9m na <a href="https://www.cnb.cz" target="_blank" rel="noopener">www.cnb.cz</a>.</li>\n    <li>Zprost\u0159edkov\u00e1n\u00ed spot\u0159ebitelsk\u00fdch nebo jin\u00fdch \u00fav\u011br\u016f (d\u00e1le jen \u201eSlu\u017eba\u201c) zp\u0159\u00edstup\u0148uje Zprost\u0159edkovatel online na sv\u00fdch webov\u00fdch str\u00e1nk\u00e1ch dostupn\u00fdch na dom\u00e9n\u011b <a href="https://creditstorm.cz" target="_blank" rel="noopener">https://creditstorm.cz</a> (d\u00e1le jen \u201eWebov\u00fd port\u00e1l\u201c). Zprost\u0159edkovatel m\u016f\u017ee provozovat svou \u010dinnost rovn\u011b\u017e na jin\u00fdch webov\u00fdch str\u00e1nk\u00e1ch. Na u\u017e\u00edv\u00e1n\u00ed jin\u00fdch webov\u00fdch str\u00e1nek Zprost\u0159edkovatele se vztahuj\u00ed obchodn\u00ed podm\u00ednky, kter\u00e9 jsou na takov\u00fdch webov\u00fdch str\u00e1nk\u00e1ch uve\u0159ejn\u011bn\u00e9.</li>\n    <li>Tyto Obchodn\u00ed podm\u00ednky upravuj\u00ed vz\u00e1jemn\u00e1 pr\u00e1va a povinnosti vznikl\u00e9 v souvislosti s vyu\u017e\u00edv\u00e1n\u00edm Webov\u00e9ho port\u00e1lu jinou fyzickou \u010di pr\u00e1vnickou osobou (\u201eU\u017eivatel\u201c), zejm\u00e9na podm\u00ednky poskytnut\u00ed Slu\u017eby Zprost\u0159edkovatele a dal\u0161\u00ed souvisej\u00edc\u00ed pr\u00e1vn\u00ed vztahy.</li>\n  </ol>\n\n  <h2>\u010cl. 2. Sjedn\u00e1n\u00ed a obsah Slu\u017eby Zprost\u0159edkovatele</h2>\n  <ol>\n    <li>Slu\u017eba Zprost\u0159edkovatele je poskytov\u00e1na v\u00fdhradn\u011b na z\u00e1klad\u011b vypln\u011bn\u00ed \u017e\u00e1dosti na Webov\u00e9m port\u00e1lu. Slu\u017ebu Zprost\u0159edkovatele si U\u017eivatel sjedn\u00e1 tak, \u017ee vypln\u00ed online \u017e\u00e1dost na Webov\u00e9m port\u00e1lu Zprost\u0159edkovatele (d\u00e1le jen \u201e\u017d\u00e1dost\u201c) po stisknut\u00ed tla\u010d\u00edtka \u201eZ\u00cdSKAT PEN\u00cdZE\u201c. V p\u0159\u00edpad\u011b, \u017ee bude U\u017eivatel p\u0159esm\u011brov\u00e1n na jak\u00e9koliv jin\u00e9 webov\u00e9 str\u00e1nky (zejm\u00e9na str\u00e1nky partnera Zprost\u0159edkovatele), tyto Obchodn\u00ed podm\u00ednky se na u\u017e\u00edv\u00e1n\u00ed a dal\u0161\u00ed \u010dinnosti U\u017eivatele (v\u010d. sjedn\u00e1v\u00e1n\u00ed konkr\u00e9tn\u00ed smlouvy) nevztahuj\u00ed.</li>\n    <li>Stisknut\u00edm tla\u010d\u00edtka \u201eZ\u00cdSKAT PEN\u00cdZE\u201c v souvislosti s vypln\u011bn\u00edm a odesl\u00e1n\u00edm \u017d\u00e1dosti na Webov\u00e9m port\u00e1lu U\u017eivatel p\u0159ij\u00edm\u00e1 tyto Obchodn\u00ed podm\u00ednky a doch\u00e1z\u00ed k uzav\u0159en\u00ed smlouvy o poskytov\u00e1n\u00ed Slu\u017eeb mezi Zprost\u0159edkovatelem a U\u017eivatelem, jej\u00ed\u017e obsah je stanoven t\u011bmito Obchodn\u00edmi podm\u00ednkami.</li>\n    <li>U\u017eivatel, kter\u00fd je spot\u0159ebitelem, m\u00e1 pr\u00e1vo od smlouvy o poskytov\u00e1n\u00ed Slu\u017eby odstoupit ve lh\u016ft\u011b \u010dtrn\u00e1ct (14) dn\u00ed ode dne jej\u00edho uzav\u0159en\u00ed, v souladu s ustanoven\u00edm \u00a7 1829 z\u00e1kona \u010d. 89/2012 Sb., ob\u010dansk\u00e9ho z\u00e1kon\u00edku. U\u017eivatel z\u00e1rove\u0148 bere na v\u011bdom\u00ed, \u017ee v p\u0159\u00edpad\u011b, \u017ee v t\u00e9to \u010dtrn\u00e1ctidenn\u00ed lh\u016ft\u011b pod\u00e1 novou \u017d\u00e1dost o poskytnut\u00ed Slu\u017eby, pozb\u00fdv\u00e1 t\u00edm pr\u00e1vo odstoupit od d\u0159\u00edve uzav\u0159en\u00e9 smlouvy o poskytov\u00e1n\u00ed Slu\u017eby.</li>\n    <li>Rozsah \u00fadaj\u016f pot\u0159ebn\u00fdch pro poskytnut\u00ed Slu\u017eby je stanoven v \u017d\u00e1dosti vypln\u011bn\u00e9 U\u017eivatelem. U\u017eivatel se zavazuje vyplnit do \u017d\u00e1dosti pouze pravdiv\u00e9, p\u0159esn\u00e9 a aktu\u00e1ln\u00ed \u00fadaje. Zprost\u0159edkovatel neov\u011b\u0159uje pravdivost \u00fadaj\u016f a neodpov\u00edd\u00e1 za zpracov\u00e1n\u00ed \u017d\u00e1dosti s nepravdiv\u00fdmi, nep\u0159esn\u00fdmi nebo neaktu\u00e1ln\u00edmi \u00fadaji. U\u017eivatel se d\u00e1le zavazuje Zprost\u0159edkovateli bezodkladn\u011b ohl\u00e1sit zm\u011bnu \u00fadaj\u016f, pokud k n\u00ed dojde.</li>\n    <li>Zpracov\u00e1n\u00ed \u00fadaj\u016f, kter\u00e9 p\u0159edstavuj\u00ed osobn\u00ed \u00fadaje U\u017eivatele, se \u0159\u00edd\u00ed Informacemi o zpracov\u00e1n\u00ed osobn\u00edch \u00fadaj\u016f zve\u0159ejn\u011bn\u00fdmi na Webov\u00e9m port\u00e1lu.</li>\n    <li>C\u00edlem Slu\u017eby Zprost\u0159edkovatele je vyhodnotit \u00fadaje U\u017eivatele a nab\u00eddnout mu finan\u010dn\u00ed produkt(y), kter\u00fd (kter\u00e9) dle odborn\u00fdch zku\u0161enost\u00ed Zprost\u0159edkovatele nejl\u00e9pe vyhovuje (vyhovuj\u00ed) po\u017eadavk\u016fm a pot\u0159eb\u00e1m U\u017eivatele. Obsahem Slu\u017eby jsou n\u00e1sleduj\u00edc\u00ed \u00fakony:\n      <ol>\n        <li>porovn\u00e1n\u00ed \u00fadaj\u016f poskytnut\u00fdch U\u017eivatelem v \u017d\u00e1dosti a krit\u00e9ri\u00ed pro poskytnut\u00ed p\u0159\u00edslu\u0161n\u00e9ho finan\u010dn\u00edho produktu stanoven\u00fdch jednotliv\u00fdmi poskytovateli \u00fav\u011br\u016f, a to v\u010detn\u011b prov\u011b\u0159en\u00ed \u00fadaj\u016f v jejich intern\u00edch datab\u00e1z\u00edch;</li>\n        <li>kontaktov\u00e1n\u00ed poskytovatele (poskytovatel\u016f) \u00fav\u011bru, jeho\u017e (jejich\u017e) produkt spl\u0148uje z\u00e1kladn\u00ed parametry \u00fav\u011bru zvolen\u00e9 U\u017eivatelem nebo se takov\u00fdm parametr\u016fm nejv\u00edce bl\u00ed\u017e\u00ed, a p\u0159ed\u00e1n\u00ed U\u017eivatelem vypln\u011bn\u00fdch \u00fadaj\u016f v \u017d\u00e1dosti tomuto poskytovateli (t\u011bmto poskytovatel\u016fm) \u00fav\u011bru.</li>\n      </ol>\n    </li>\n    <li>U\u017eivatel bere na v\u011bdom\u00ed, \u017ee za \u00fa\u010delem roz\u0161\u00ed\u0159en\u00ed nab\u00eddky finan\u010dn\u00edch produkt\u016f vyhovuj\u00edc\u00edch U\u017eivateli dle jeho po\u017eadavk\u016f a pot\u0159eb je Zprost\u0159edkovatel v r\u00e1mci Slu\u017eby opr\u00e1vn\u011bn rovn\u011b\u017e kontaktovat jin\u00e9 zprost\u0159edkovatele \u00fav\u011br\u016f a p\u0159edat jim U\u017eivatelem vypln\u011bn\u00e9 \u00fadaje v \u017d\u00e1dosti.</li>\n    <li>Slu\u017eba nezahrnuje poskytnut\u00ed samotn\u00e9ho \u00fav\u011bru. Zprost\u0159edkovatel nezaru\u010duje U\u017eivateli, \u017ee obdr\u017e\u00ed nab\u00eddku \u00fav\u011bru.</li>\n    <li>Slu\u017eba je U\u017eivateli poskytov\u00e1na bezplatn\u011b. Zprost\u0159edkovatel pob\u00edr\u00e1 odm\u011bnu za zprost\u0159edkov\u00e1n\u00ed uzav\u0159en\u00ed smlouvy mezi U\u017eivatelem a poskytovatelem \u00fav\u011bru v\u00fdhradn\u011b od poskytovatel\u016f \u00fav\u011bru.</li>\n  </ol>\n\n  <h2>\u010cl. 3. Dal\u0161\u00ed informace souvisej\u00edc\u00ed s poskytov\u00e1n\u00edm Slu\u017eby</h2>\n  <ol>\n    <li>U\u017eivatel bere na v\u011bdom\u00ed, \u017ee Zprost\u0159edkovatel je samostatn\u00fdm zprost\u0159edkovatelem spot\u0159ebitelsk\u00e9ho \u00fav\u011bru ve smyslu ZS\u00da. Na z\u00e1klad\u011b sjedn\u00e1n\u00ed smlouvy o poskytnut\u00ed Slu\u017eby Zprost\u0159edkovatele nedoch\u00e1z\u00ed ke zprost\u0159edkov\u00e1n\u00ed spot\u0159ebitelsk\u00e9ho \u00fav\u011bru jm\u00e9nem a na \u00fa\u010det U\u017eivatele jako spot\u0159ebitele. Tyto Podm\u00ednky nep\u0159edstavuj\u00ed smlouvu o zprost\u0159edkov\u00e1n\u00ed spot\u0159ebitelsk\u00e9ho \u00fav\u011bru, ani \u017e\u00e1dn\u00e9 jin\u00e9 zvl\u00e1\u0161tn\u00ed ujedn\u00e1n\u00ed mezi zprost\u0159edkovatelem a spot\u0159ebitelem dle ZS\u00da.</li>\n    <li>U\u017eivatel d\u00e1le bere na v\u011bdom\u00ed, \u017ee poskytovatel\u00e9 \u00fav\u011bru jsou dle p\u0159\u00edslu\u0161n\u00fdch pr\u00e1vn\u00edch p\u0159edpis\u016f (zejm\u00e9na podle ustanoven\u00ed \u00a7 20z a \u00a7 20za z\u00e1kona \u010d. 634/1992 Sb., o ochran\u011b spot\u0159ebitele) opr\u00e1vn\u011bni se prost\u0159ednictv\u00edm informa\u010dn\u00edch datab\u00e1z\u00ed (d\u00e1le jen \u201eRegistr\u201c) vz\u00e1jemn\u011b informovat o identifika\u010dn\u00edch \u00fadaj\u00edch spot\u0159ebitel\u016f a o z\u00e1le\u017eitostech, kter\u00e9 vypov\u00eddaj\u00ed o bonit\u011b, platebn\u00ed mor\u00e1lce a d\u016fv\u011bryhodnosti spot\u0159ebitel\u016f. Pro \u00fa\u010dely posouzen\u00ed mo\u017enosti poskytnout \u00fav\u011br, o kter\u00fd U\u017eivatel projevil v \u017d\u00e1dosti z\u00e1jem, budou U\u017eivatelem vypln\u011bn\u00e9 \u00fadaje poskytovateli \u00fav\u011bru pou\u017eity k nahl\u00e9dnut\u00ed zejm\u00e9na do t\u011bchto Registr\u016f:\n      <ol>\n        <li>registr\u016f z\u00e1jmov\u00e9ho sdru\u017een\u00ed pr\u00e1vnick\u00fdch osob SOLUS (I\u010cO 69346925),</li>\n        <li>registru CBCB \u2013 Czech Banking Credit Bureau, a.s. (BRKI, I\u010cO 26199696),</li>\n        <li>registru CNCB \u2013 Czech Non-Banking Credit Bureau, z.s.p.o. (NRKI, I\u010cO 71236384)</li>\n        <li>registr\u016f spole\u010dnost\u00ed CRIF - Czech Credit Bureau (I\u010cO 26212242)</li>\n        <li>registru spole\u010dnosti CRIF - Registr platebn\u00edch informac\u00ed s. r. o. (REPI, I\u010cO 05775809)</li>\n        <li>registru Spole\u010dnosti pro informa\u010dn\u00ed datab\u00e1ze, a.s. (TelcoScore, I\u010cO 26118513)</li>\n        <li>registru z\u00e1jmov\u00e9ho spolku Asociace poskytovatel\u016f nebankovn\u00edch \u00fav\u011br\u016f (I\u010c 02734311),</li>\n        <li>registru spole\u010dnosti Sokordia, s.r.o, I\u010cO 29190088</li>\n        <li>insolven\u010dn\u00edho rejst\u0159\u00edku (ISIR),</li>\n        <li>datab\u00e1ze Ministerstva vnitra \u010cesk\u00e9 republiky pro ov\u011b\u0159en\u00ed platnosti osobn\u00edch doklad\u016f.</li>\n      </ol>\n    </li>\n    <li>Vypln\u011bn\u00e1 \u017d\u00e1dost U\u017eivatele a tyto Obchodn\u00ed podm\u00ednky jsou ulo\u017eeny u Zprost\u0159edkovatele v elektronick\u00e9 podob\u011b. Smlouva o poskytnut\u00ed Slu\u017eby Zprost\u0159edkovatele je uzav\u00edr\u00e1na v \u010desk\u00e9m jazyce.</li>\n    <li>V p\u0159\u00edpad\u011b spor\u016f souvisej\u00edc\u00edch se smlouvou o zprost\u0159edkov\u00e1n\u00ed spot\u0159ebitelsk\u00e9m \u00fav\u011bru se m\u016f\u017eete obr\u00e1tit tak\u00e9 na finan\u010dn\u00edho arbitra (Finan\u010dn\u00ed arbitr \u010cesk\u00e9 republiky, Legerova 1581/69, 110 00 Praha 1). Bli\u017e\u0161\u00ed podm\u00ednky a zp\u016fsob vy\u0159izov\u00e1n\u00ed t\u011bchto spor\u016f je upraven v z\u00e1kon\u011b \u010d. 229/2002 Sb., o finan\u010dn\u00edm arbitrovi, v platn\u00e9m zn\u011bn\u00ed, a takt\u00e9\u017e na webov\u00fdch str\u00e1nk\u00e1ch finan\u010dn\u00edho arbitra <a href="https://www.finarbitr.cz" target="_blank" rel="noopener">www.finarbitr.cz</a>. Org\u00e1nem vykon\u00e1vaj\u00edc\u00edm dohled nad dodr\u017eov\u00e1n\u00edm povinnost\u00ed stanoven\u00fdch ZS\u00da je \u010cesk\u00e1 n\u00e1rodn\u00ed banka se s\u00eddlem Na P\u0159\u00edkop\u011b 28, 115 03 Praha 1, <a href="https://www.cnb.cz" target="_blank" rel="noopener">www.cnb.cz</a>.</li>\n  </ol>\n\n  <h2>\u010cl. 4. Z\u00e1v\u011bre\u010dn\u00e1 ustanoven\u00ed</h2>\n  <ol>\n    <li>Smlouva o poskytnut\u00ed Slu\u017eby Zprost\u0159edkovatele se uzav\u00edr\u00e1 na dobu ur\u010ditou v d\u00e9lce deset (10) let.</li>\n    <li>Ka\u017ed\u00e1 ze stran m\u016f\u017ee smlouvu o poskytnut\u00ed Slu\u017eby ukon\u010dit v\u00fdpov\u011bd\u00ed i bez ud\u00e1n\u00ed d\u016fvodu, a to doru\u010den\u00edm p\u00edsemn\u00e9 v\u00fdpov\u011bdi na adresu druh\u00e9 smluvn\u00ed strany, tj. na adresu s\u00eddla Zprost\u0159edkovatele, pokud jde o v\u00fdpov\u011b\u010f ze strany U\u017eivatele, nebo na adresu uvedenou U\u017eivatelem v \u017d\u00e1dosti, pokud jde o v\u00fdpov\u011b\u010f ze strany Zprost\u0159edkovatele. U\u017eivatel bere na v\u011bdom\u00ed, \u017ee s ohledem na povahu Slu\u017eby se ukon\u010den\u00ed smlouvy nedot\u00fdk\u00e1 ji\u017e poskytnut\u00e9 Slu\u017eby, v\u010detn\u011b p\u0159ed\u00e1n\u00ed \u00fadaj\u016f poskytovateli finan\u010dn\u00edho produktu v souladu s t\u011bmito Obchodn\u00edmi podm\u00ednkami.</li>\n    <li>Pr\u00e1vn\u00ed vztah mezi U\u017eivatelem a Zprost\u0159edkovatelem se \u0159\u00edd\u00ed p\u0159\u00edslu\u0161n\u00fdmi platn\u00fdmi pr\u00e1vn\u00edmi p\u0159edpisy pr\u00e1vn\u00edho \u0159\u00e1du \u010cesk\u00e9 republiky. Nen\u00ed-li v t\u011bchto Obchodn\u00edch podm\u00ednk\u00e1ch stanoveno jinak, p\u0159\u00edpadn\u00e9 spory mezi U\u017eivatelem a Zprost\u0159edkovatelem (d\u00e1le jen \u201eSmluvn\u00ed strany\u201c) budou \u0159e\u0161eny p\u0159ed obecn\u00fdmi soudy \u010cesk\u00e9 republiky.</li>\n    <li>U\u017eivatel, kter\u00fd je spot\u0159ebitelem, se pro \u0159e\u0161en\u00ed p\u0159\u00edpadn\u00fdch spor\u016f mimosoudn\u00ed cestou m\u016f\u017ee obr\u00e1tit na\n      <ol>\n        <li>kancel\u00e1\u0159 finan\u010dn\u00edho arbitra (Legerova 1581/69 110 00 Praha 1, e-mail: <a href="mailto:arbitr@finarbitr.cz">arbitr@finarbitr.cz</a>, ID datov\u00e9 schr\u00e1nky: qr9ab9x);</li>\n        <li>platformu RSO na \u0159e\u0161en\u00ed spor\u016f, provozovanou Evropskou Komis\u00ed, v jazyku, kter\u00fd si zvol\u00ed, v souladu s \u010dl\u00e1nkem 14 Na\u0159\u00edzen\u00ed Evropsk\u00e9ho parlamentu a Rady (EU) \u010d. 524/2013 ze dne 21. kv\u011btna 2013 o \u0159e\u0161en\u00ed spot\u0159ebitelsk\u00fdch spor\u016f on-line a o zm\u011bn\u011b na\u0159\u00edzen\u00ed (ES) \u010d. 2006/2004 a sm\u011brnice 2009/22/ES (na\u0159\u00edzen\u00ed o \u0159e\u0161en\u00ed spot\u0159ebitelsk\u00fdch spor\u016f on-line). Platforma RSO je p\u0159\u00edstupn\u00e1 online na: <a href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home.chooseLanguage" target="_blank" rel="noopener">https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home.chooseLanguage</a></li>\n      </ol>\n    </li>\n    <li>Je-li n\u011bkter\u00e9 ustanoven\u00ed t\u011bchto Obchodn\u00edch podm\u00ednek neplatn\u00e9 nebo nevynutiteln\u00e9 nebo stane-li se neplatn\u00fdm \u010di nevynutiteln\u00fdm v budoucnu nebo bude za takov\u00e9 prohl\u00e1\u0161eno rozhodnut\u00edm soudu \u010di jin\u00e9ho p\u0159\u00edslu\u0161en\u00e9ho org\u00e1nu, nen\u00ed t\u00edm dot\u010dena platnost a vynutitelnost ostatn\u00edch ustanoven\u00ed t\u011bchto Obchodn\u00edch podm\u00ednek. Nam\u00edsto neplatn\u00e9ho \u010di nevynutiteln\u00e9ho ustanoven\u00ed nastoup\u00ed nov\u00e9, platn\u00e9 a vynutiteln\u00e9 ustanoven\u00ed, kter\u00e9 se sv\u00fdm obsahem bude neplatn\u00e9mu \u010di nevynutiteln\u00e9mu ustanoven\u00ed co nejv\u00edce p\u0159ibli\u017eovat.</li>\n    <li>Zn\u011bn\u00ed t\u011bchto Obchodn\u00edch podm\u00ednek m\u016f\u017ee Zprost\u0159edkovatel jednostrann\u011b m\u011bnit \u010di dopl\u0148ovat. Zm\u011bny zn\u011bn\u00ed Obchodn\u00edch podm\u00ednek nemaj\u00ed retroaktivn\u00ed \u00fa\u010dinek v\u016f\u010di smlouv\u00e1m o poskytnut\u00ed Slu\u017eby uzav\u0159en\u00fdm v minulosti. Pod\u00e1n\u00edm nov\u00e9 \u017d\u00e1dosti na Webov\u00e9m port\u00e1lu v\u0161ak doch\u00e1z\u00ed k uzav\u0159en\u00ed nov\u00e9 smlouvy o poskytnut\u00ed Slu\u017eby, na ni\u017e se vztahuj\u00ed Obchodn\u00ed podm\u00ednky ve zn\u011bn\u00ed, jak\u00e9 maj\u00ed v moment\u011b odesl\u00e1n\u00ed \u017d\u00e1dosti. U\u017eivatel p\u0159ed odesl\u00e1n\u00edm ka\u017ed\u00e9 \u017d\u00e1dosti vyjad\u0159uje souhlas s aktu\u00e1ln\u00edm zn\u011bn\u00edm Obchodn\u00edch podm\u00ednek.</li>\n    <li class="effective-date">Tyto Obchodn\u00ed podm\u00ednky nab\u00fdvaj\u00ed \u00fa\u010dinnosti dnem 01.08.2023.</li>\n  </ol>\n</div>'
              }
            />

            <Button
              data-plasmic-name={"button"}
              data-plasmic-override={overrides.button}
              className={classNames("__wab_instance", sty.button)}
              color={"success"}
              label={
                <div
                  data-plasmic-name={"text"}
                  data-plasmic-override={overrides.text}
                  className={classNames("all", "__wab_text", sty.text)}
                >
                  {"P\u0159e\u010detl/a jsem si podm\u00ednky slu\u017eby"}
                </div>
              }
              onClick={async event => {
                const $steps = {};

                $steps["runCode"] = true
                  ? (() => {
                      const actionArgs = {
                        customFunction: async () => {
                          return window.close();
                        }
                      };
                      return (({ customFunction }) => {
                        return customFunction();
                      })?.apply(null, [actionArgs]);
                    })()
                  : undefined;
                if (
                  $steps["runCode"] != null &&
                  typeof $steps["runCode"] === "object" &&
                  typeof $steps["runCode"].then === "function"
                ) {
                  $steps["runCode"] = await $steps["runCode"];
                }
              }}
              size={"large"}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "freeBox", "embedHtml", "button", "text"],
  freeBox: ["freeBox", "embedHtml", "button", "text"],
  embedHtml: ["embedHtml"],
  button: ["button", "text"],
  text: ["text"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  freeBox: "div";
  embedHtml: typeof Embed;
  button: typeof Button;
  text: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicTC__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicTC__VariantsArgs;
    args?: PlasmicTC__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicTC__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicTC__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicTC__ArgProps,
          internalVariantPropNames: PlasmicTC__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicTC__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicTC";
  } else {
    func.displayName = `PlasmicTC.${nodeName}`;
  }
  return func;
}

export const PlasmicTC = Object.assign(
  // Top-level PlasmicTC renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    freeBox: makeNodeComponent("freeBox"),
    embedHtml: makeNodeComponent("embedHtml"),
    button: makeNodeComponent("button"),
    text: makeNodeComponent("text"),

    // Metadata about props expected for PlasmicTC
    internalVariantProps: PlasmicTC__VariantProps,
    internalArgProps: PlasmicTC__ArgProps,

    pageMetadata: generateDynamicMetadata(wrapQueriesWithLoadingProxy({}), {
      pageRoute: "/terms",
      pagePath: "/terms",
      params: {},
      query: {}
    })
  }
);

export default PlasmicTC;
/* prettier-ignore-end */
